/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type NotificationEmailUpdateMutationVariables = Types.Exact<{
  input: Types.NotificationEmailInput;
}>;


export type NotificationEmailUpdateMutation = { __typename: 'Mutation', notificationEmailUpdate: { __typename: 'NotificationSettingsModel', id: string, status: Types.NotificationStatus, emailAddresses: Array<string> } };


export const NotificationEmailUpdateDocument = gql`
    mutation notificationEmailUpdate($input: NotificationEmailInput!) {
  notificationEmailUpdate(input: $input) {
    id
    status
    emailAddresses
  }
}
    `;
export type NotificationEmailUpdateMutationFn = ApolloReactCommon.MutationFunction<NotificationEmailUpdateMutation, NotificationEmailUpdateMutationVariables>;

/**
 * __useNotificationEmailUpdateMutation__
 *
 * To run a mutation, you first call `useNotificationEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationEmailUpdateMutation, { data, loading, error }] = useNotificationEmailUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationEmailUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NotificationEmailUpdateMutation, NotificationEmailUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NotificationEmailUpdateMutation, NotificationEmailUpdateMutationVariables>(NotificationEmailUpdateDocument, options);
      }
export type NotificationEmailUpdateMutationHookResult = ReturnType<typeof useNotificationEmailUpdateMutation>;
export type NotificationEmailUpdateMutationResult = ApolloReactCommon.MutationResult<NotificationEmailUpdateMutation>;
export type NotificationEmailUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<NotificationEmailUpdateMutation, NotificationEmailUpdateMutationVariables>;